var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "254.5px",
    height: "200px",
    viewBox: "0 0 254.5 200",
    style: {
      enableBackground: "new 0 0 254.5 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "path1_fill",
    d: "M0.1,101.9c0.1,0.2,0.2,0.5,0.3,0.8c0.1,0.4,0.2,0.7,0.3,1c0.1,0.4,0.3,0.7,0.5,1c0.1,0.2,0.2,0.5,0.4,0.7 c0.3,0.5,0.7,1.1,1.2,1.5l90.7,90.3c1.9,1.9,4.4,2.8,6.9,2.8s5-0.9,6.9-2.8c3.8-3.8,3.8-9.9,0-13.7l-74.1-73.8h211.7 c5.4,0,9.7-4.4,9.7-9.7s-4.3-9.7-9.7-9.7H33.2l74.1-73.8c3.8-3.8,3.8-9.9,0-13.7s-9.9-3.8-13.7,0L2.9,93.1c-0.4,0.5-0.8,1-1.2,1.5 c-0.2,0.2-0.3,0.5-0.4,0.7c-0.2,0.4-0.4,0.7-0.5,1c-0.1,0.4-0.2,0.7-0.3,1c-0.1,0.2-0.2,0.5-0.3,0.8C0,99.4,0,100.6,0.1,101.9z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left.2cd3fd2f.svg";
export { ForwardRef as ReactComponent };